<template>
  <!-- footer section start-->
  <footer class="footer">
    <div class="container footer-container">
      <!-- Left: Copyright -->
      <p class="footer-copy">Copyright © KIMSHEALTH Trivandrum - All Rights Reserved | Developed by <a href="https://www.kenland.in/" class="footer-copy" target="_blank">Kenland IT Solutions Pvt. Ltd.</a></p>
      <!-- Right: Footer Navigation -->
      <nav class="footer-nav">
        <a :href="privacy_policy"   target="_blank">Privacy Policy</a>
        <!-- <a href="https://visamedical.kimshealth.org/refund-policy"    target="_blank">Refund Policy</a> -->
        <a :href="terms_and_conditions" target="_blank">Terms & Conditions</a>
        <!-- <a href="#contact" target="_blank">Certifications</a> -->
      </nav>
          
    </div>
  </footer>
  <!-- Footer section end -->
</template>
<script>
  export default {
    name: 'DownBar',
    components: {},
    data() {
      return {
          privacy_policy : '/privacy-policy',
          terms_and_conditions : '/terms-conditions',
      };
    },
  }
</script>